import { Component, inject, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { LoggerService } from '@danangelus/ngx-app-core'
import { InputGroupModule } from 'primeng/inputgroup'
import { TextareaModule } from 'primeng/textarea'
import { MessageModule } from 'primeng/message'
import { AppManagerService } from '../../../../core/services/app-manager.service'

const log = LoggerService.get('LoginMessageComponent')

/**
 * Login Message update component (Can edit the login message as admin)
 *
 * @author Adam Jennings
 */
@Component({
    selector: 'login-message',
    standalone: true,
    imports: [
        FormsModule,
        InputGroupModule,
        MessageModule,
        TextareaModule,
    ],
    templateUrl: './login-message.component.html',
    styleUrl: './login-message.component.sass'
})
export class LoginMessageComponent implements OnInit {

    protected appService = inject(AppManagerService)

    loginMessage: string | null | undefined
    messageType = ''

    async ngOnInit(): Promise<void> {
        await this.appService.loadLoginMessage()
        this.loginMessage = await this.appService.getLoginMessage()
    }

    async saveMessage() {
        log.info('sendMessage', 'Updating Login message...')
        this.appService.setLoginMessage(this.loginMessage!)
        await this.appService.storeLoginMessage()
        this.messageType = 'CHANGES_SAVED'
    }
}
